import { Link } from '@thoughtspot/radiant-react/widgets/link';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import { getDocumentationLink } from '@thoughtspot/session-service';
import React from 'react';
export const SubTitleComponent = ({ title, learnMore, }) => (React.createElement(React.Fragment, null, title !== '' && (React.createElement(Typography, { variant: "p", color: Colors.grayLight },
    title,
    learnMore ? (React.createElement(Link, { href: `${getDocumentationLink(learnMore.url)}`, target: learnMore.newWindow ? '_blank' : undefined, rel: "noreferrer" }, learnMore.text)) : null))));
export const Subtitle = React.memo(SubTitleComponent);
//# sourceMappingURL=subtitle.js.map